export const MULTISTEP_FORM_LOCAL_STORAGE_KEY = 'gift-wrapping:multistep';
export const initialContext = {
    giftbox: '',
    variant: '',
    items: [],
    giftboxMessage: '',
    complimentaryMessage: ''
};
